<template>
  <div class="course-outline">
    <div class="course-outline__title">
      <div class="title__number">{{ syllabusModule.name }}（{{ syllabusModule.desc }}次课）</div>
      <div class="title__deadline" v-if="validDay">
        {{ validDay }}
      </div>
    </div>
    <div class="course-outline__schedule" ref="syllabus">
      <template v-if="Number(outlinesNumber) > 0">
        <div v-for="(data, i) of syllabusModule.list" :key="i" class="schedules__new">
          <div class="syllabus__title" v-if="data.name" :class="{'hidden': i > 0 && isShowMore}">
            {{ data.name }}
          </div>
          <div class="unit-list">
            <div class="unit" v-for="(unit, n) of data.list" :key="n" >
              <div :class="['unit-head', {'unit-hidden': (i > 0 || unit.lessonIndex > 2) && isShowMore, 'unit-show': !isShowMore}]">
                <div class="unit__header-num" v-if="unit.name">{{ unit.name }}:</div>
                <div class="unit__header-name" v-if="unit.subTitle">{{ unit.subTitle }}</div>
              </div>
              <div  v-for="(item, j) of unit.list" :key="j">
                <div :class="['schedule__list', {'outline-hidden': (i > 0 || item.lessonIndex > 2) && isShowMore, 'outline-show': !isShowMore}]">
                  <div :class="['item__header', item.subCatalogList && item.subCatalogList.length > 0 ? '' : 'item__header--no-suboutline']">
                    <div class="item__header-num">{{ item.serialNo }}</div>
                    <div class="item__header-name">{{ item.name }}</div>
                    <div class="item__header--reval">
                      <div class="item__header--wrap">
                        <div class="item__header-time" v-if="item.timeName"> {{ item.timeName }}</div>
                        <div class="item__header-status" v-if="item.statusDesc" :style="{ color: item.statusDesc && item.statusDesc.textColor }">{{ item.statusDesc && item.statusDesc.name }}</div>
                      </div>
                      <div class="item__header--wrap">
                        <div class="item__header-time" v-if="item.answerLiveTimeDesc">{{ item.answerLiveTimeDesc }}</div>
                        <div class="item__header-status" v-if="item.qaStatusDesc" :style="{ color: item.qaStatusDesc && item.qaStatusDesc.textColor }">{{ item.qaStatusDesc && item.qaStatusDesc.name }}</div>
                      </div>
                    </div>
                  </div>
                  <template  v-if="item.subCatalogList && item.subCatalogList.length > 0">
                    <div class="item__subcontent" v-for="(subItem, k) of item.subCatalogList" :key="k">
                      <div class="subcontent__header">
                        <img class="subcontent__header-icon" src="./img/schedule.png" />
                        <div class="subcontent__header-title">{{ subItem.name }}</div>
                      </div>
                      <div class="subcontent__list">
                        <div class="subcontent__list-item" :class="{ iscore: subListItem.isCore == 1 }" v-for="(subListItem, x) of subItem.list" :key="x">
                          <div class="time">{{ subListItem.time }}</div>
                          <div class="name">{{ subListItem.name }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div
      class="course-outline__btn"
      @click="handleOutline($event)"
      v-if="Number(outlinesNumber) > 3"
    >
      <div class="course-outline__btn__content">
        <span class="course-outline__btn__content__text">{{
          isShowMore ? '查看全部大纲' : '收起大纲'
        }}</span>
        <span
          class="course-outline__btn__content__img"
          :class="{ rotate: !isShowMore }"
        ></span>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
// import methods from '@/views/CourseDetail/mixins/methods'
export default {
  // mixins: [methods],
  props: {
    syllabusModule: {
      type: Object,
      default: () => {}
    },
    validDay: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      outlinesNumber: null,
      schedules: null,
      sliceOutlines: [],
      isShowMore: true,
      showOutlineNum: 3
    }
  },
  inject: ['initTabInfo'],
  mounted() {
    if (Number(this.syllabusModule.count) > 0) {
      this.outlinesNumber = this.syllabusModule.count
      this.courseOutlines = cloneDeep(this.syllabusModule.list)
      this.sliceOutlines = this.syllabusModule.list.slice(0, this.showOutlineNum)
    }
  },
  methods: {
    handleOutline() {
      this.isShowMore = !this.isShowMore
      this.$nextTick(() => {
        this.initTabInfo()
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
.syllabus__title {
    margin-top: 30px;
    font-size: 18px;
    color: #333333;
    line-height: 24px;
    &.hidden{
      display: none;
    }
}
@include b(course-outline) {
  margin-top: 40px;
  .outline-hidden {
    display: none;
  }
  .outline-show {
    display: block;
  }
  @include e(title) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      display: inline-block;
    }
  }
  @include e(btn) {
    margin-top: 18px;
    position: relative;
    height: 16px;
    @include e(content) {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      cursor: pointer;
      text-align: center;
      color: #666666;
      & > span {
        display: inline-block;
      }
      &:hover {
        color: #999999;
        .course-outline__btn__content__img {
          height: 14px;
          width: 14px;
          background: url('../images/up_gray.png');
          background-size: 14px 14px;
          vertical-align: middle;
        }
      }
      @include e(text) {
        font-size: 14px;
        vertical-align: middle;
        margin-right: 8px;
      }
      @include e(img) {
        height: 14px;
        width: 14px;
        background: url('../images/up.png');
        background-size: 14px 14px;
        vertical-align: middle;
      }
    }
  }
  @include e(schedule) {
    margin-top: 2px;
  }
}
@include b(title) {
  @include e(number) {
    font-size: 18px;
    color: #333333;
    line-height: 24px;
  }
  @include e(deadline) {
    color: #999999;
    font-size: 14px;
  }
}
@include b(schedule-item) {
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > span {
    display: inline-block;
    line-height: 34px;
    color: #666666;
    font-size: 14px;
  }
  @include e(title) {
    @include m(XUNI) {
      display: inline-block;
      // overflow: hidden;
      // text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  @include e(state) {
    color: #999999;
  }
  @include e(name) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.rotate {
  transform: rotate(180deg);
}
.clear {
  clear: both;
}
.schedule-title {
  font-size: 16px;
  color: #333333;
  line-height: 36px;
  margin-top: 8px;
}
// .schedules__new {
  .unit-list{
    .unit-head {
      &.unit-hidden {
        display: none;
      }
      &.unit-show {
        display: flex;
      }
      display: flex;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
      margin-top:32px;
      .unit__header-num {
        margin-right: 12px
      }
    }
    .schedule__list {
    box-sizing: border-box;
    padding: 30px 0;
    border-bottom: 1px solid #EFEFEF;
  }

  .schedule__list .item__header {
    position: relative;
    min-height: 22px;
    display: flex;
    margin-bottom: 30px;

    &--no-suboutline{
      margin-bottom: 0px;
    }

    .item__header-num, .item__header-name, .item__header-time, .item__header-status {
      text-align: left;
      font-family: MicrosoftYaHei;
      width: 87px;
    }

    .item__header-num {
      margin-right:16px;
      color: #666666;
      font-size: 16px;
    }

    .item__header-name {
      width: 313px;
      color: #333333;
      font-size: 16px;
    }
    .item__header--reval {
      display: flex;
      flex-direction: column;
    }
    .item__header--wrap {
      display: flex;
      justify-content: flex-start;
      &:last-child {
        margin-top: 10px;
      }
    }

    .item__header-time {
      width: 324px;
      color: #666666;
      font-size: 14px;
    }

    .item__header-status {
      color: #666666;
      font-size: 14px;
      white-space: nowrap;
    }
  }

  .schedule__list .item__subcontent + .item__subcontent {
    margin-top: 30px;
  }

  .schedule__list .item__subcontent {
    width: 100%;
    box-sizing: border-box;
    padding-left: 66px;

    .subcontent__header {
      height: 14px;
      display: flex;
      align-items: center;

      .subcontent__header-icon {
        width: 12px;
        margin-right: 8px;
        height: 12px;
      }

      .subcontent__header-title {
        color: #333333;
        font-size: 14px;
      }
    }

    .subcontent__list {
      overflow: hidden;
      box-sizing: border-box;
      padding-left: 20px;
      .subcontent__list-item {
        width: 33.333%;
        float: left;
        margin-top: 12px;
        display: flex;
        color: #999999;
        font-size: 14px;
        .time {
          margin-right: 10px;
        }
      }

      .subcontent__list-item.iscore {
        color: #BE8243;
      }
    }
  }
  }
  


</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/CourseOutline.vue